import React from 'react';
import { useState } from "react";
import '../../App.css';
import { Link } from 'react-router-dom';
import { auth } from "../../firebase-config.js";
import { User } from "../../UserContext.js";
import {
    signInWithEmailAndPassword,
    onAuthStateChanged,
    signOut
} from "firebase/auth";
import { useContext } from 'react';


export default function Admin() {

    const [loginEmail, setLoginEmail] = useState("");
    const [loginSenha, setLoginSenha] = useState("");
    const [loginError, setLoginError] = useState(false);

    const [user, setUser] = useContext(User);

    onAuthStateChanged(auth, (currentUser) => {
        setUser(currentUser);
    });

    const login = async () => {
        try {
            const user = await signInWithEmailAndPassword(
                auth,
                loginEmail,
                loginSenha
            );
            console.log(user);
            setLoginError(false);
            window.location.href = '/perfil'
        } catch (error) {
            console.log(error.message);
            setLoginError(true);
        }
    };

    const handleEnter = (e) => {
        if (e === 13)
        {
            login();
        }
    }

    if (user != null) {
        window.location.href = '/perfil'
    }
    

    return <>
        <body className='admin'>
            <div class="login">
                <div>
                    <h1 className='loginTitle'>
                        Fazer Login
                    </h1>
                    {loginError ?
                        <div className="loginError">
                            <h4 className="loginErrorText"> Email/Senha Inv&aacute;lido </h4>
                        </div> :
                        <></>
                    }
                </div>
                <div className='loginEmail'>
                    <h3 className='loginEmailTitle'>
                        Email
                    </h3>
                    <input
                        className='loginEmailBox'
                        onChange={(event) => {
                            setLoginEmail(event.target.value);
                        }}
                        onKeyDown={(event) => { handleEnter(event) }}
                    />
                </div>
                <div className='loginSenha'>
                    <h3 className='loginSenhaTitle'>
                        Senha
                    </h3>
                    <input
                        className='loginSenhaBox'
                        type="password"
                        onChange={(event) => {
                            setLoginSenha(event.target.value);
                        }}
                        onKeyDown={(event) => { handleEnter(event.keyCode) }}
                    />
                </div>
                <div className='loginBtnDiv'>
                    <button onClick={login} className='login-btn'>
                        Login
                    </button>
                </div>
            </div>
        </body>
    </>;

}